// Mock data for development — will be replaced by Supabase queries
import { theme } from './theme';

export const mockLeads = [
  { id: 1, name: 'Sarah Mitchell', type: 'Buyer', source: 'Referral', status: 'New', time: '2 hours ago', phone: '856-555-0142', email: 'sarah.m@email.com', budget: '$350K-$400K', notes: 'Looking in Cherry Hill area, 3BR minimum', priority: 'high', entity: 'Brokerage', assigned_to: 'Jenifer Raffa' },
  { id: 2, name: 'David Chen', type: 'Renter', source: 'Sign Call', status: 'Contacted', time: 'Yesterday', phone: '856-555-0198', email: '', budget: '$1,800/mo', notes: 'Needs 2BR, pet-friendly, move-in by May', priority: 'medium', entity: 'Property Management', assigned_to: 'Neha' },
  { id: 3, name: 'Maria Rodriguez', type: 'Seller', source: 'Website', status: 'New', time: '3 hours ago', phone: '609-555-0167', email: 'maria.r@email.com', budget: 'Listing $425K', notes: 'Inherited property, wants quick sale', priority: 'high', entity: 'Brokerage', assigned_to: 'Jenifer Raffa' },
  { id: 4, name: 'James Wilson', type: 'Buyer', source: 'Referral', status: 'Qualified', time: '2 days ago', phone: '856-555-0234', email: 'jwilson@email.com', budget: '$500K-$600K', notes: 'Pre-approved, relocating from NY', priority: 'medium', entity: 'Brokerage', assigned_to: 'Sylvia Micarelli' },
  { id: 5, name: 'Lisa Thompson', type: 'Renter', source: 'Facebook', status: 'New', time: '5 hours ago', phone: '856-555-0311', email: '', budget: '$1,500/mo', notes: 'Single mom, needs good school district', priority: 'low', entity: 'Property Management', assigned_to: 'Neha' },
];

export const mockMaintenanceRequests = [
  { id: 1, property: '142 Oak Street, Unit 3', tenant: 'Robert Barnes', issue: 'Leaking kitchen faucet', priority: 'medium', status: 'Quotes In', time: '1 hour ago', category: 'Plumbing' },
  { id: 2, property: '85 Maple Ave, Unit 1', tenant: 'Jessica Torres', issue: 'AC not cooling — 85°F inside', priority: 'urgent', status: 'AI Dispatched', time: '30 min ago', category: 'HVAC' },
  { id: 5, property: '302 Elm Street', tenant: 'Carlos Rivera', issue: 'Water heater not working — no hot water', priority: 'urgent', status: 'Emergency', time: '20 min ago', category: 'Plumbing' },
  { id: 4, property: '15 Cedar Lane, Unit 2', tenant: 'Amy Patel', issue: 'Smoke detector beeping', priority: 'low', status: 'New', time: '3 hours ago', category: 'Safety' },
];

export const mockVendorQuotes = {
  1: [
    { vendor: "Joe's Plumbing", quote: '$150-180', avail: 'Tomorrow 9am', status: 'quoted', rating: 4.8, jobs: 23 },
    { vendor: 'South Jersey Plumbing', quote: '$200', avail: 'Thursday', status: 'quoted', rating: 4.5, jobs: 15 },
    { vendor: 'AllFix Handyman', quote: null, avail: null, status: 'pending', rating: 4.2, jobs: 8 },
  ],
  5: [
    { vendor: "Joe's Plumbing", quote: 'Assess on-site', avail: 'Within 1 hour', status: 'confirmed', rating: 4.8, jobs: 23, first: true },
    { vendor: 'Emergency Plumbing 24/7', quote: '$250 call-out', avail: 'Within 45 min', status: 'quoted', rating: 4.0, jobs: 5 },
  ],
};

export const mockPropertyVendors = {
  '142 Oak Street, Unit 3': [
    { name: "Joe's Plumbing", pref: 'required', note: "Owner's preferred — used for 5 years" },
    { name: 'AllFix Handyman', pref: 'preferred', note: '' },
  ],
  '85 Maple Ave, Unit 1': [
    { name: 'ComfortAir HVAC', pref: 'preferred', note: 'Good rates for this building' },
    { name: 'Budget Plumbing', pref: 'blocked', note: 'Owner had bad experience' },
  ],
  '302 Elm Street': [
    { name: "Joe's Plumbing", pref: 'approved', note: '' },
    { name: 'Emergency Plumbing 24/7', pref: 'approved', note: 'After-hours only' },
  ],
};

export const mockTransactions = [
  // Buyer rep — post-contract, at Inspection step (index 8 in BUYER_MILESTONES)
  {
    id: 1, propertyAddress: '456 Cherry Hill Rd', type: 'Buyer',
    transactionType: 'Buyer Rep', clientName: 'Thompson Family', agentName: 'Sylvia Micarelli',
    currentMilestoneIndex: 8, milestoneDate: '2026-04-11', price: 385000,
  },
  // Seller rep — active marketing, at Showings & Open Houses (index 5 in SELLER_MILESTONES)
  {
    id: 2, propertyAddress: '789 Washington Ave', type: 'Seller',
    transactionType: 'Seller Rep', clientName: 'Frank Moretti', agentName: 'Johanna Micarelli',
    currentMilestoneIndex: 5, milestoneDate: '2026-04-20', price: 425000,
  },
  // Buyer rep — early post-contract, at Attorney Review (index 7 in BUYER_MILESTONES)
  {
    id: 3, propertyAddress: '123 Haddonfield Rd', type: 'Buyer',
    transactionType: 'Buyer Rep', clientName: 'Nguyen Family', agentName: 'Jenifer Raffa',
    currentMilestoneIndex: 7, milestoneDate: '2026-04-12', price: 520000,
  },
  // Seller rep — pre-contract, at Listed on MLS (index 4 in SELLER_MILESTONES)
  {
    id: 4, propertyAddress: '55 Broad St', type: 'Seller',
    transactionType: 'Seller Rep', clientName: 'Maria Rodriguez', agentName: 'Jenifer Raffa',
    currentMilestoneIndex: 4, milestoneDate: '2026-04-09', price: 325000,
  },
  // Commercial Seller Rep — at Buyer Outreach & Tours (index 3 in COMMERCIAL_SELLER_MILESTONES)
  {
    id: 5, propertyAddress: '1010 Route 70', type: 'Seller', propertyType: 'Commercial',
    transactionType: 'Commercial Seller Rep', clientName: 'Garden State Holdings LLC', agentName: 'Patricia Furrow',
    currentMilestoneIndex: 3, milestoneDate: '2026-04-30', price: 1200000,
  },
  // Commercial Buyer Rep — at LOI Submitted (index 4 in COMMERCIAL_BUYER_MILESTONES)
  {
    id: 6, propertyAddress: '250 Kings Hwy, Suite 200', type: 'Buyer', propertyType: 'Commercial',
    transactionType: 'Commercial Buyer Rep', clientName: 'NJ Dental Group', agentName: 'Jenifer Raffa',
    currentMilestoneIndex: 4, milestoneDate: '2026-04-14', price: 875000,
  },
];

export const mockBrokerageData = {
  revenue: '$18,400',
  pending: '$42,500',
  activeDeals: 4,
  pipeline: '3 pending',
  // Numeric versions for drill-down calculations
  revenueMTD: 18400,
  pendingCommissions: 42500,
  pipelineCount: 3,
};

export const mockPMData = {
  revenue: '$8,200',
  pending: '$3,400',
  activeUnits: 12,
  pipeline: '2 renewals',
  // Numeric versions for drill-down calculations
  revenueMTD: 8200,
  pendingAmount: 3400,
  upcomingRenewals: 2,
};

// Agent-level commission breakdown for Brokerage drill-down
export const mockAgentCommissions = [
  {
    agentId: 1, agentName: 'Jenifer Raffa', role: 'Broker/Owner',
    splitPercent: 100, // Broker keeps 100% of her own deals
    totalEarned: 28750, totalPaid: 14200, totalPending: 14550,
    activeDeals: 2, closedDeals: 1,
    deals: [
      { id: 101, property: '123 Haddonfield Rd', client: 'Nguyen Family', type: 'Buyer Rep', price: 520000, commissionRate: 2.5, grossCommission: 13000, agentSplit: 13000, brokerSplit: 0, status: 'Pending', closeDate: '2026-05-15', paidDate: null },
      { id: 102, property: '55 Broad St', client: 'Maria Rodriguez', type: 'Seller Rep', price: 325000, commissionRate: 3.0, grossCommission: 9750, agentSplit: 9750, brokerSplit: 0, status: 'Active', closeDate: null, paidDate: null },
      { id: 103, property: '250 Kings Hwy, Suite 200', client: 'NJ Dental Group', type: 'Commercial Buyer Rep', price: 875000, commissionRate: 2.0, grossCommission: 17500, agentSplit: 17500, brokerSplit: 0, status: 'Pending', closeDate: '2026-05-30', paidDate: null },
      { id: 104, property: '88 Voorhees Dr', client: 'Patterson Family', type: 'Buyer Rep', price: 410000, commissionRate: 2.5, grossCommission: 10250, agentSplit: 10250, brokerSplit: 0, status: 'Closed', closeDate: '2026-03-12', paidDate: '2026-03-20' },
    ],
  },
  {
    agentId: 2, agentName: 'Sylvia Micarelli', role: 'Agent',
    splitPercent: 70, // 70/30 split
    totalEarned: 6737.50, totalPaid: 6737.50, totalPending: 0,
    activeDeals: 1, closedDeals: 1,
    deals: [
      { id: 201, property: '456 Cherry Hill Rd', client: 'Thompson Family', type: 'Buyer Rep', price: 385000, commissionRate: 3.0, grossCommission: 11550, agentSplit: 8085, brokerSplit: 3465, status: 'Pending', closeDate: '2026-05-01', paidDate: null },
      { id: 202, property: '92 Taunton Rd', client: 'Kim Family', type: 'Buyer Rep', price: 295000, commissionRate: 2.5, grossCommission: 7375, agentSplit: 5162.50, brokerSplit: 2212.50, status: 'Closed', closeDate: '2026-02-28', paidDate: '2026-03-08' },
    ],
  },
  {
    agentId: 3, agentName: 'Johanna Micarelli', role: 'Agent',
    splitPercent: 70,
    totalEarned: 0, totalPaid: 0, totalPending: 8925,
    activeDeals: 1, closedDeals: 0,
    deals: [
      { id: 301, property: '789 Washington Ave', client: 'Frank Moretti', type: 'Seller Rep', price: 425000, commissionRate: 3.0, grossCommission: 12750, agentSplit: 8925, brokerSplit: 3825, status: 'Active', closeDate: null, paidDate: null },
    ],
  },
  {
    agentId: 4, agentName: 'Patricia Furrow', role: 'Agent',
    splitPercent: 65, // 65/35 commercial split
    totalEarned: 0, totalPaid: 0, totalPending: 15600,
    activeDeals: 1, closedDeals: 0,
    deals: [
      { id: 401, property: '1010 Route 70', client: 'Garden State Holdings LLC', type: 'Commercial Seller Rep', price: 1200000, commissionRate: 2.0, grossCommission: 24000, agentSplit: 15600, brokerSplit: 8400, status: 'Active', closeDate: null, paidDate: null },
    ],
  },
];

// PM Property-level breakdown for PM drill-down
export const mockPMProperties = [
  {
    propertyId: 1, address: '142 Oak Street', owner: 'Robert Greenfield', ownerEmail: 'rgreenfield@email.com',
    units: 4, occupiedUnits: 4, monthlyRent: 7200, mgmtFeePercent: 8,
    mgmtFeeMonthly: 576, ytdRevenue: 2304, ytdExpenses: 1425,
    leases: [
      { unit: 'Unit 1', tenant: 'Sarah Kim', rent: 1800, leaseEnd: '2026-09-30', status: 'Active' },
      { unit: 'Unit 2', tenant: 'Michael Brown', rent: 1800, leaseEnd: '2026-06-15', status: 'Renewal Pending' },
      { unit: 'Unit 3', tenant: 'Robert Barnes', rent: 1800, leaseEnd: '2027-01-31', status: 'Active' },
      { unit: 'Unit 4', tenant: 'Diana Lopez', rent: 1800, leaseEnd: '2026-12-31', status: 'Active' },
    ],
    recentExpenses: [
      { date: '2026-04-06', description: "Joe's Plumbing — Unit 3 faucet", amount: 175, category: 'Plumbing' },
      { date: '2026-03-15', description: 'Lawn care — March', amount: 250, category: 'Landscaping' },
      { date: '2026-02-20', description: 'Snow removal', amount: 400, category: 'Grounds' },
      { date: '2026-01-10', description: 'Fire extinguisher inspection', amount: 600, category: 'Safety' },
    ],
  },
  {
    propertyId: 2, address: '85 Maple Ave', owner: 'Sunrise Investments LLC', ownerEmail: 'admin@sunriseinv.com',
    units: 3, occupiedUnits: 3, monthlyRent: 5400, mgmtFeePercent: 8,
    mgmtFeeMonthly: 432, ytdRevenue: 1728, ytdExpenses: 950,
    leases: [
      { unit: 'Unit 1', tenant: 'Jessica Torres', rent: 1800, leaseEnd: '2026-08-31', status: 'Active' },
      { unit: 'Unit 2', tenant: 'Ahmad Hassan', rent: 1800, leaseEnd: '2026-11-30', status: 'Active' },
      { unit: 'Unit 3', tenant: 'Emily Watson', rent: 1800, leaseEnd: '2026-07-15', status: 'Active' },
    ],
    recentExpenses: [
      { date: '2026-04-03', description: 'ComfortAir HVAC — Unit 1', amount: 350, category: 'HVAC' },
      { date: '2026-03-01', description: 'Hallway painting', amount: 600, category: 'Maintenance' },
    ],
  },
  {
    propertyId: 3, address: '302 Elm Street', owner: 'Patricia & David Chen', ownerEmail: 'pchen@email.com',
    units: 1, occupiedUnits: 1, monthlyRent: 2200, mgmtFeePercent: 10,
    mgmtFeeMonthly: 220, ytdRevenue: 880, ytdExpenses: 0,
    leases: [
      { unit: 'Main', tenant: 'Carlos Rivera', rent: 2200, leaseEnd: '2026-10-31', status: 'Active' },
    ],
    recentExpenses: [],
  },
  {
    propertyId: 4, address: '15 Cedar Lane', owner: 'Robert Greenfield', ownerEmail: 'rgreenfield@email.com',
    units: 4, occupiedUnits: 3, monthlyRent: 5400, mgmtFeePercent: 8,
    mgmtFeeMonthly: 432, ytdRevenue: 1728, ytdExpenses: 200,
    leases: [
      { unit: 'Unit 1', tenant: 'Amy Patel', rent: 1800, leaseEnd: '2026-05-05', status: 'Renewal Pending' },
      { unit: 'Unit 2', tenant: 'Stephanie Brown', rent: 1800, leaseEnd: '2026-05-05', status: 'Renewal Pending' },
      { unit: 'Unit 3', tenant: 'James Wright', rent: 1800, leaseEnd: '2026-12-31', status: 'Active' },
      { unit: 'Unit 4', tenant: null, rent: 1800, leaseEnd: null, status: 'Vacant' },
    ],
    recentExpenses: [
      { date: '2026-03-20', description: 'Smoke detector replacement — Unit 2', amount: 200, category: 'Safety' },
    ],
  },
];

export const mockReconciliation = [
  { account: 'Trust Account', status: 'Reconciled', date: 'Apr 1', color: theme.colors.success, accountName: 'Trust Account', lastReconciledDate: '2026-04-01' },
  { account: 'Operating Account', status: '3 items pending', date: 'Apr 5', color: theme.colors.warning, accountName: 'Operating Account', lastReconciledDate: '2026-04-05' },
  { account: 'PM Security Deposits', status: 'Reconciled', date: 'Apr 1', color: theme.colors.success, accountName: 'PM Security Deposits', lastReconciledDate: '2026-04-01' },
];

export const mockRecentTransactions = [
  { date: 'Apr 7', description: 'Commission — 456 Cherry Hill Rd', amount: '+$11,550', numericAmount: 11550, entity: 'Brokerage', type: 'income' },
  { date: 'Apr 6', description: 'Joe\'s Plumbing — 142 Oak St', amount: '-$175', numericAmount: -175, entity: 'PM', type: 'expense' },
  { date: 'Apr 5', description: 'Rent collected — 85 Maple Ave', amount: '+$1,800', numericAmount: 1800, entity: 'PM', type: 'income' },
  { date: 'Apr 4', description: 'Agent split — Sylvia M.', amount: '-$8,085', numericAmount: -8085, entity: 'Brokerage', type: 'expense' },
  { date: 'Apr 3', description: 'ComfortAir HVAC — 85 Maple Ave', amount: '-$350', numericAmount: -350, entity: 'PM', type: 'expense' },
];

export const mockDashboardStats = {
  leads: mockLeads.length,
  maintenance: mockMaintenanceRequests.length,
  transactions: 6,
  revenue: '$18.4K',
  autoResponded: 2,
  autoDispatched: 1,
  renewalFlags: 3,
  attentionItems: [
    { title: 'No hot water — 302 Elm Street', subtitle: 'Carlos Rivera • 20 min ago', badge: 'URGENT', color: theme.colors.danger },
    { title: 'Counter offer due tomorrow — 1010 Route 70', subtitle: 'NJ Dental Group • Patricia Furrow', badge: '1 DAY', color: theme.colors.warning },
    { title: 'New seller lead — Maria Rodriguez', subtitle: 'Inherited property, wants quick sale', badge: 'NEW', color: theme.colors.info },
    { title: 'Lease expires in 23 days — 15 Cedar Lane', subtitle: 'Stephanie Brown • Negotiating renewal', badge: '23 DAYS', color: theme.colors.accent },
  ],
  schedule: [
    { time: '10:00 AM', title: 'Showing — 789 Washington Ave', subtitle: 'Johanna M. with seller' },
    { time: '1:00 PM', title: 'Listing appointment', subtitle: '55 Broad St — new seller lead' },
    { time: '3:30 PM', title: 'Vendor meeting — ComfortAir', subtitle: '85 Maple Ave HVAC quote review' },
  ],
  aiLog: [
    { action: 'Auto-responded to Sarah Mitchell (new buyer lead)', time: '2 hours ago', color: theme.colors.info },
    { action: 'Dispatched ComfortAir HVAC to 85 Maple Ave', time: '30 min ago', color: theme.colors.success },
    { action: 'Flagged lease renewal — 15 Cedar Lane (23 days)', time: '1 hour ago', color: theme.colors.warning },
    { action: 'Sent multi-quote request for 142 Oak St faucet', time: '45 min ago', color: theme.colors.info },
  ],
};
